module.exports = __webpack_public_path__ + "static/img/pickup-singlecab-bluegrey.1af9730.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/pickup-singlecab-bluegrey.svg
// module id = seKb
// module chunks = 74